/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Ganturin Vladimir <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Pipe, PipeTransform} from '@angular/core';

/**
 * Адаптивное форматирование размера файла: `< 1024` → в `units[0]`, дальше делим на 1024
 * с адаптивной точностью (`>= 10` → целое, иначе 1 знак). `units` начинается с единицы
 * байтов, например `['Б','КБ','МБ','ГБ','ТБ']` (или локализованный массив). Возвращает
 * `null` для `null`/отрицательных. Отличается от `FormatSizePipe` (тот — английский, 2 знака).
 */
export function formatFileSize(bytes: number | null | undefined, units: readonly string[]): string | null {
  if (bytes == null || bytes < 0) {
    return null;
  }
  if (bytes < 1024) {
    return `${bytes} ${units[0]}`;
  }
  let value = bytes / 1024;
  let i = 1;
  while (value >= 1024 && i < units.length - 1) {
    value /= 1024;
    i++;
  }
  return `${value >= 10 ? value.toFixed(0) : value.toFixed(1)} ${units[i]}`;
}

@Pipe({
  name: 'formatSize',
})
export class FormatSizePipe implements PipeTransform {

  transform(bytes: number): string {
    if (bytes < 1) {
      return '';
    }

    const k = 1024;
    const dm = 2;
    const sizes = ['Bytes', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb', 'Zb', 'Yb'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}
